import React from 'react';
import { motion } from 'framer-motion';
export function Services() {
  const services = [{
    title: 'Class A Motorhome',
    desc: 'Safe and secure nationwide RV transport for luxury Class A motorhomes, drive-away or towed.',
    img: 'https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Class B Camper Van',
    desc: 'Specialized handling and fast shipping logistics for camper vans and adventure vehicles.',
    img: 'https://images.unsplash.com/photo-1565034946487-077786996e27?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Class C Motorhome',
    desc: 'Expert transport coordination for Class C motorhomes, ensuring safe hauling coast-to-coast.',
    img: 'https://images.unsplash.com/photo-1513311068348-19c8fbdc0bb6?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Travel Trailer',
    desc: 'Dedicated transport solutions designed specifically for the safe hauling of travel trailers.',
    img: 'https://images.unsplash.com/photo-1563385150878-522648d0b27e?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Fifth Wheel',
    desc: 'Affordable and reliable transport for large fifth-wheel trailers, handled by experienced RV movers.',
    img: 'https://images.unsplash.com/photo-1559405886-c4e11649c065?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Toy Hauler',
    desc: 'Secure transport for toy haulers, ensuring your RV and cargo arrive safely at your destination.',
    img: 'https://images.unsplash.com/photo-1580828369019-181321f238bc?q=80&w=800&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-brand-navy text-white" data-id="element-267">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-268">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-270">
            Comprehensive RV Transport Services
          </h2>
          <p className="text-lg text-slate-300" data-id="element-271">
            From travel trailers to luxury Class A motorhomes, our RV movers
            have the equipment and expertise to handle any RV hauling
            requirement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-272">
          {services.map((service, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="group relative overflow-hidden rounded-2xl bg-brand-navy-light border border-white/10" data-id="element-273">
              <div className="aspect-w-16 aspect-h-9 w-full h-64 overflow-hidden" data-id="element-274">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-275" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/40 to-transparent" data-id="element-276"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-277">
                <h3 className="text-2xl font-bold mb-2" data-id="element-278">{service.title}</h3>
                <p className="text-slate-300" data-id="element-279">{service.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}